module.exports = __webpack_public_path__ + "water.svg?198769035412b88ded9306871c85db19";